export const colors = {
  // Base colors
  background: '#F2F5F7',
  textPrimary: '#222222',
  textLight: '#777777',
  textSecondary: '#666666',
  btnBgColorPrimary: '#306FC9',
  btnBgColorHover: '#F2F5F7',
  btnTextColorPrimary: '#FFFFFF',
  btnTextColorHover: '#306FC9',
  buttonBlue: '#3e62ad',
  white: '#FFFFFF',
  bgHover: '#f8f9fa',

  // Blue shades (for charts and demographics)
  blue: {
    700: '#1e4a8a',
    600: '#2557a8',
    500: '#306FC9',
    400: '#82C9FF',
    300: '#BFDCFF',
    200: '#75ADFE',
    100: '#9EC3F8',
    50: '#BFE9FF',
  },

  // Chart blue shades (alternative blue palette for charts)
  chartBlue: {
    900: '#1E40AF',
    800: '#2563EB',
    600: '#3B82F6',
    500: '#60A5FA',
    400: '#93C5FD',
    300: '#BFDBFE',
    200: '#DBEAFE',
    150: '#e7f1ff',
    100: '#EFF6FF',
  },

  // Gray shades
  gray: {
    700: '#495057',
    600: '#6c757d',
    500: '#6B7280',
    400: '#9CA3AF',
    300: '#F3F4F6',
    200: '#E5E7EB',
    100: '#F2F5F7',
    50: '#F9FAFB',
  },

  // Border colors
  border: '#cccccc',
  borderLight: '#eeeeee',
  borderGray: '#ededed',
  borderMediumGray: '#D0D0D0',

  // Trend colors
  trendUp: '#4DB672',
  trendDown: '#EF4444',
  trendSame: '#6B7280',

  // Status colors
  success: '#10B981',
  error: '#EF4444',
  errorBg: '#FEF2F2',
  errorDark: '#DC2626',
  warning: '#F59E0B',

  // Event status colors
  eventCrowded: '#E74B4B',
  eventCrowdedBit: '#FFDD00',
  eventCrowdedModerate: '#4DB672',
  eventCrowdedNone: '#CCCCCC',

  // Disabled/inactive colors
  disabled: '#D1D5DB',

  // Toggle button colors
  toggle: {
    active: '#306FC9',
    inactive: '#D1D5DB',
  },

  // Overlay and shadow colors
  overlayBg: 'rgba(0, 0, 0, 0.5)',
  shadowColor: 'rgba(0, 0, 0, 0.1)',
  shadowMedium: 'rgba(0, 0, 0, 0.15)',
  shadowDark: 'rgba(0, 0, 0, 0.2)',

  // Language Switcher specific
  shadowPrimary: 'rgba(48, 111, 201, 0.4)',
  shadowPrimaryHover: 'rgba(48, 111, 201, 0.5)',
  bgActive: '#e8f0fe',
  textActive: '#1967d2',
  borderMedium: '#e0e0e0',
  bgHoverLight: '#f5f5f5',
};
